import { OrderFulfill } from '../../../pb/events/v1/order_fulfill_pb';

type Listener = (event: OrderFulfill) => void;

const listeners = new Set<Listener>();

export const emitOrderFulfill = (event: OrderFulfill): void => {
    listeners.forEach((listener) => listener(event));
};

export const subscribeToOrderFulfill = (listener: Listener): VoidFunction => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};
